<body>
    <div id="page" class="page">
       <!-- ***site header html start*** -->
       <app-smart-header></app-smart-header>
       <!-- ***site header html end*** -->
       <main id="content" class="site-main">
          <section class="contact-inner-page">
            <!-- Photo by <a href="https://unsplash.com/@freestocks?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">freestocks</a> on <a href="https://unsplash.com/photos/selective-focus-photography-of-person-using-smartphone-mw6Onwg4frY?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
             <!-- ***Inner Banner html start form here*** -->
             <div class="inner-banner-wrap">
                <div class="inner-baner-container" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/9fd12bf8-0e76-47dd-306c-586441de4100/public);">
                   <div class="container">
                      <div class="inner-banner-content">
                         <h1 class="page-title" style="margin-top: 2rem;">CONTACTO</h1>
                      </div>
                   </div>
                </div>
             </div>
             <!-- ***Inner Banner html end here*** -->
             <!-- ***contact section html start form here*** -->
             <div class="inner-contact-wrap">
                <div class="container">
                   <div class="row">
                      <div class="col-lg-6">
                         <div class="section-heading">
                            <h5 class="sub-title">MENSAJE O VIDEOLLAMADA</h5>
                            <h2 class="section-title">HABLEMOS!</h2>
                            <p>¡Tu opinión es muy importante para nosotros! Si tenés alguna pregunta o comentario no dudés en llenar el formulario de abajo o enviarnos un correo directamente a <strong>voyjaleas.cr@gmail.com</strong>. Nos esforzamos por responder a todos los mensajes lo antes posible.</p>
                            <div class="social-icon">
                               <ul>
                                  <li>
                                     <a href="https://www.facebook.com/voyjaleas" target="_blank">
                                        <i class="fab fa-facebook-f" aria-hidden="true"></i>
                                     </a>
                                  </li>
                                  <li>
                                    <a href="https://www.tiktok.com/@voyjaleas" target="_blank">
                                       <i class="fab fa-tiktok" aria-hidden="true"></i>
                                    </a>
                                 </li>
                                  <li>
                                     <a href="https://www.youtube.com/voyjaleas" target="_blank">
                                        <i class="fab fa-youtube" aria-hidden="true"></i>
                                     </a>
                                  </li>
                                  <li>
                                     <a href="https://www.instagram.com/voyjaleas" target="_blank">
                                        <i class="fab fa-instagram" aria-hidden="true"></i>
                                     </a>
                                  </li>
                               </ul>
                            </div>
                         </div>
                         <div class="contact-map">
                           <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/874052b5-b25b-4e06-e387-c8e31e971800/public">
                           <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.540423056448!2d-0.12174238402827448!3d51.50330061882345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604b900d26973%3A0x4291f3172409ea92!2slastminute.com%20London%20Eye!5e0!3m2!1sen!2snp!4v1646314586610!5m2!1sen!2snp" width="600" height="400" style="border:0;" allowfullscreen="" loading="lazy"></iframe> -->
                         </div>
                      </div>
                      <div class="col-lg-6">
                         <div class="contact-from-wrap primary-bg" *ngIf="!showSuccessMessage">
                            <form method="get" class="contact-from">
                               <p>
                                  <label>Nombre</label>
                                  <input type="text" name="name" placeholder="Nombre*"  [(ngModel)]="newVoyJaleasContactFormEntry.name">
                               </p>
                               <p>
                                  <label>Email</label>
                                  <input type="email" name="email" placeholder="Email*"  [(ngModel)]="newVoyJaleasContactFormEntry.email">
                               </p>
                               <p>
                                  <label>Mensaje / Pregunta / Duda</label>
                                  <textarea rows="8" placeholder="Mensaje*" name="message" [(ngModel)]="newVoyJaleasContactFormEntry.message"></textarea>
                               </p>
                               <p>
                                  <input type="button" name="submit" (click)="sendMessage()" value="ENVIAR MENSAJE" style="border: 2px solid white;">
                               </p>
                            </form>
                         </div>

                         <div class="success-notify" *ngIf="showSuccessMessage">
                           <div class="success-icon">
                              <i class="fas fa-check"></i>
                           </div>
                           <div class="success-content">
                              <h3>MENSAJE RECIBIDO</h3>
                              <p>Gracias por tu interés. Nos pondremos en contacto para los siguientes pasos.</p>
                           </div>
                        </div>
                      </div>
                   </div>
                </div>
             </div>
             <!-- ***contact section html start form here*** -->
             <!-- ***iconbox section html start form here*** -->
             <div class="contact-details-section bg-light-grey">
                <div class="container">
                   <div class="row align-items-center">
                      <div class="col-lg-4">
                         <div class="icon-box border-icon-box">
                            <div class="box-icon">
                               <i aria-hidden="true" class="fas fa-envelope-open-text"></i>
                            </div>
                            <div class="icon-box-content">
                               <h4>CORREO ELECTRÓNICO</h4>
                               <ul>
                                  <li>
                                     <a href="mailto:support@gmail.com">voyjaleas.cr@gmail.com</a>
                                  </li>
                                  <li>
                                     <a href="mailto:name@comapny.com">info@voyjaleas.com</a>
                                  </li>
                               </ul>
                            </div>
                         </div>
                      </div>
                      <div class="col-lg-4">
                         <div class="icon-box border-icon-box">
                            <div class="box-icon">
                               <i aria-hidden="true" class="fas fa-phone-alt"></i>
                            </div>
                            <div class="icon-box-content">
                               <h4>TELÉFONO</h4>
                               <ul>
                                  <li>
                                     <a href="tell:+132599254669">(+34) 602 52 31 56</a>
                                  </li>
                               </ul>
                            </div>
                         </div>
                      </div>
                      <div class="col-lg-4">
                         <div class="icon-box border-icon-box">
                            <div class="box-icon">
                               <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
                            </div>
                            <div class="icon-box-content">
                               <h4>DÓNDE ESTAMOS</h4>
                               <ul>
                                  <li>
                                     Madrid, España
                                  </li>
                                  <li>
                                     Barcelona, España
                                  </li>
                                  <li>
                                     San José, Costa Rica
                                  </li>
                               </ul>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
             <!-- ***iconbox section html end here*** -->
          </section>
       </main>
       <!-- ***site footer html start form here*** -->

      <app-banner-cta-full-width></app-banner-cta-full-width>

      

       <app-smart-footer></app-smart-footer>

       <!-- ***site footer html end*** -->
       <a id="backTotop" href="#" class="to-top-icon">
          <i class="fas fa-chevron-up"></i>
       </a>
       <!-- ***custom search field html*** -->
       <div class="header-search-form">
          <div class="container">
             <div class="header-search-container">
                <form class="search-form" role="search" method="get" >
                   <input type="text" name="s" placeholder="Enter your text...">
                </form>
                <a href="#" class="search-close">
                   <i class="fas fa-times"></i>
                </a>
             </div>
          </div>
       </div>
       <!-- ***custom search field html*** -->
       <!-- ***custom top bar offcanvas html*** -->
       <div id="offCanvas" class="offcanvas-container">
          <div class="offcanvas-inner">
             <div class="offcanvas-sidebar">
                <aside class="widget author_widget">
                   <h3 class="widget-title">OUR PROPRIETOR</h3>
                   <div class="widget-content text-center"> 
                      <div class="profile"> 
                         <figure class="avatar"> 
                            <img src="assets/images/img21.jpg" alt=""> 
                         </figure> 
                         <div class="text-content"> 
                            <div class="name-title"> 
                               <h4> James Watson</h4> 
                            </div> 
                            <p>Accumsan? Aliquet nobis doloremque, aliqua? Inceptos voluptatem, duis tempore optio quae animi viverra distinctio cumque vivamus, earum congue, anim velit</p> 
                         </div> 
                         <div class="socialgroup"> 
                            <ul> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-facebook"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-google"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-twitter"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-instagram"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-pinterest"></i> </a> </li> 
                            </ul> 
                         </div> 
                      </div> 
                   </div>
                </aside>
                <aside class="widget widget_text text-center">
                   <h3 class="widget-title">CONTACT US</h3>
                   <div class="textwidget widget-text">
                      <p>Feel free to contact and<br/> reach us !!</p>
                      <ul>
                         <li>
                            <a href="tel:+01988256203">
                               <i aria-hidden="true" class="icon icon-phone1"></i>
                               +01(988) 256 203
                            </a>
                         </li>
                         <li>
                            <a href="mailtop:info@domain.com">
                               <i aria-hidden="true" class="icon icon-envelope1"></i>
                               info@domain.com
                            </a>
                         </li>
                         <li>
                            <i aria-hidden="true" class="icon icon-map-marker1"></i>
                            3146 Koontz, California
                         </li>
                      </ul>
                   </div>
                </aside>
             </div>
             <a href="#" class="offcanvas-close">
                <i class="fas fa-times"></i>
             </a>
          </div>
          <div class="overlay"></div>
       </div>
       <!-- ***custom top bar offcanvas html*** -->
    </div>

 </body>